import { useEffect } from 'react';
import ProjectUtils from "../../../utils/project-utils.js";

const AutoDatetime = ({ setFilters, hasSeconds = true }) => {

    useEffect(() => {

        const autocomplete = (input) => {
            if (!input || !input.id) return;
            if (!["dtStart", "dtEnd", "hrStart", "hrEnd"].includes(input.id)) return;
            let result = null;

            const hasTime = (value) => {
                if (!value) return false;
                return /\d{2}:\d{2}(:\d{2})?$/.test(value.trim());
            };

            if(input.id === "dtStart" || input.id === "dtEnd" ){
                const mode = input.id === "dtEnd" ? "end" : "start";
                const hasHours = hasTime(input.value);

                result = ProjectUtils.formatDateInput(input.value, hasHours, mode);
                if (!result) return;
            }

            if(input.id === "hrStart" || input.id === "hrEnd" ){
                result = ProjectUtils.formatHourInput(input.value, hasSeconds);
                if (!result) return;
            }

            if(!result) return;

            input.value = result.formatted;

            setFilters(prev => ({
                ...prev,
                [input.id]: result.date
            }));
        };

        const blurHandler = (e) => {
            autocomplete(e.target);
        };

        const keyHandler = (e) => {
            if (e.key !== "Enter") return;
            autocomplete(e.target);
        };

        document.addEventListener("blur", blurHandler, true);
        document.addEventListener("keydown", keyHandler);

        return () => {
            document.removeEventListener("blur", blurHandler, true);
            document.removeEventListener("keydown", keyHandler);
        };

    }, [setFilters]);

    return null;
};

export default AutoDatetime;